<template>
  <el-dropdown trigger="click" class="international" @command="handleSetLanguage">
    <div class="icon_box" :title="$t('titles.langChange')">
      <img src="../assets/icon/language.png" alt="">
    </div>
    <el-dropdown-menu slot="dropdown">
      <template v-for="item in langOptions">
        <el-dropdown-item :disabled="$i18n.locale == item.value" :command="item.value">
          {{item.name}}
        </el-dropdown-item>
      </template>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>

import { getProjectValueMap, getModuleValueMap } from '@/api'
export default {
  data () {
    return {
      langOptions: [
        { name: 'English', value: 'en' },
        { name: '简体中文', value: 'zh_CN' },
        { name: '繁体中文', value: 'zh_HK' },
        { name: '한국어', value: 'ko' },
        { name: '日本語', value: 'ja' },
        { name: 'Deutsch', value: 'de' },
        { name: 'Français', value: 'fr' }
      ],
      msg: {}
    }
  },
  mounted () {
    this.getLanguage()
  },
  
  methods: {
    mergeObjects(target, ...sources) {
        for (const source of sources) {
            for (const key in source) {
                if (source.hasOwnProperty(key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    },
    getCharger () {
      getModuleValueMap(this.$i18n.locale, { 
        module: 'index',
        project: 'charger-app'
      }).then(res => {
        console.log('chargerIndex:', res)
        if (res.resultCode == 1001 && res.resultModel) {
          // this.$i18n.setLocaleMessage(lang, Object.assign(this.$i18n.messages[lang], { 'chargerIndex': res.resultModel }))
          this.msg = this.mergeObjects(this.msg, { 'chargerIndex': res.resultModel })
          this.$i18n.setLocaleMessage(this.$i18n.locale, this.msg)

          var arr = []
          for (var attr in res.resultModel) {
            if (attr.indexOf('event_') > -1) {
              arr.push({
                label: res.resultModel[attr],
                value: attr.slice(6)
              })
            }
          }
          this.$store.dispatch('setChargerOption', arr)
        }
      })
    },
    getDrmIndex () {
       // 获取drm-index
      getModuleValueMap(this.$i18n.locale, {
        project: 'drm-system',
        module: 'index'
      }).then(res => {
        console.log('drm-system index', res)
        if (res.resultCode == 1001 && res.resultModel) {
          // this.$i18n.setLocaleMessage(lang, Object.assign(this.$i18n.messages[lang], { 'index': res.resultModel }))
          this.msg = this.mergeObjects(this.msg, { 'index': res.resultModel })
        }
        this.getCharger()
      })
    },
    getDrmLog () {
      // 获取日志国际化字符串
      getModuleValueMap(this.$i18n.locale, {
        project: 'drm-system',
        module: 'device_log'
      }).then(res => {
        console.log('drm-system device_log', res)
        if (res.resultCode == 1001 && res.resultModel) {
          // this.$i18n.setLocaleMessage(lang, Object.assign(this.$i18n.messages[lang], { 'device_log': res.resultModel }))
          this.msg = this.mergeObjects(this.msg, { 'device_log': res.resultModel })
        }
        this.getDrmIndex()
      })
    },
    getLanguage () {
      
      const lang = this.$i18n.locale
      this.msg = this.$i18n.messages[lang]
      getProjectValueMap(lang).then(res => {
        console.log('admin2020:', res)
        if (res.resultCode == 1001 && res.resultModel) {
          this.msg = this.mergeObjects(this.msg, res.resultModel)
          // console.log(this.msg)
          // this.$i18n.setLocaleMessage(lang, Object.assign(this.$i18n.messages[lang], res.resultModel))
        }
        this.getDrmLog()
      })
      
    },
    handleSetLanguage (lang) {

      this.$i18n.locale = lang
      this.$store.dispatch('setLanguage', lang)

      this.getLanguage()

      if (lang === 'zh') {
        this.$store.dispatch('setMap', 'gdMap')
      } else {
        this.$store.dispatch('setMap', 'ggMap')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.icon_box {
  img {
    width: 16px;
  }
}
</style>
